import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=217524fc&"
import script from "./SubTitle.vue?vue&type=script&lang=ts&"
export * from "./SubTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports